// import React, { useCallback, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Image from "./Image";
import Video from "./Video";
import AliceCarousel from "react-alice-carousel";

export default function PostModal(props) {
  const {
    title,
    show,
    image,
    url,
    handleClose,
    is_video,
    videoSrc,
    is_gallery,
    gallerySources,
  } = props;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body>
        <p>{title}</p>
        {image && <Image url={url} />}
        {is_video && <Video videoSrc={videoSrc} />}
        {is_gallery && (
          <div className="xxx">
            <AliceCarousel
              items={gallerySources}
              fadeOutAnimation={true}
              mouseTrackingEnabled={true}
              disableAutoPlayOnAction={true}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary">Save changes</Button>
      </Modal.Footer>
    </Modal>
  );
}
